import { useTranslation } from 'react-i18next';
import styles from './NotFound.module.scss';

import React from 'react';
import { EmptyState as ReportIcon } from 'components/icons';

type Props = {
  title: string;
  hasSearch: boolean;
  notFoundTitle: string;
  subtitle?: string;
  /** Действие под текстом — например «Повторить» для состояния ошибки. */
  footer?: React.ReactNode;
};

export const NotFound = ({ title, notFoundTitle, subtitle, hasSearch, footer }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.notFound}>
      <ReportIcon />
      <span className={styles.textNotFound}>
        {hasSearch ? (
          <span>{t(notFoundTitle)}</span>
        ) : (
          <div>
            <span>{t(title)}</span>
            {subtitle && <div style={{ textAlign: 'center' }}>{t(subtitle)}</div>}
          </div>
        )}
      </span>
      {footer ? <div className={styles.footer}>{footer}</div> : null}
    </div>
  );
};

export const NotFoundContainer = ({ children }: React.PropsWithChildren) => (
  <div className={styles.notFoundContainer}>{children}</div>
);
